var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4804_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.93442 22 0 17.0656 0 11C0 4.93442 4.93442 0 11 0C17.0656 0 22 4.93442 22 11C22 17.0656 17.0656 22 11 22ZM11 0.916667C5.44042 0.916667 0.916667 5.44042 0.916667 11C0.916667 16.5596 5.44042 21.0833 11 21.0833C16.5596 21.0833 21.0833 16.5596 21.0833 11C21.0833 5.44042 16.5596 0.916667 11 0.916667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 14.2109C7.18567 14.2109 7.04083 14.1394 6.95192 14.0065C6.81167 13.7966 6.8685 13.5115 7.07933 13.3713L10.9999 10.7569V5.04427C10.9999 4.79127 11.2053 4.58594 11.4583 4.58594C11.7113 4.58594 11.9166 4.79127 11.9166 5.04427V11.0026C11.9166 11.1557 11.8396 11.2987 11.7122 11.3839L7.58717 14.1339C7.50925 14.1862 7.42033 14.2109 7.33325 14.2109Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4804_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.0274f528a8b54b19168448e23c404aaa.svg";
export { ForwardRef as ReactComponent };